import { useState, useEffect } from "react"
import styles from "./Options.module.css"
import syncOffline from "../../offlineSync"
// import Dropdown from "./Dropdown"

const Options = ({ month, setMonth, sortMethod, setSortMethod, locations, location, setLocation }) => {
    const toggleSeasonal = () => {
        const d = new Date()
        month === 0 ? setMonth(d.getMonth() + 1) : setMonth(0)
    }
    const toggleSort = () => {
        setSortMethod(sortMethod === 'related' ? 'common' : 'related')
    }

    const [syncState, setSyncState] = useState('idle') // idle | syncing | done | error
    const [syncProgress, setSyncProgress] = useState({ done: 0, total: 0 })

    // a new location needs its own sync
    useEffect(() => { setSyncState('idle') }, [location.slug])

    const handleSync = async () => {
        if (syncState === 'syncing') return
        setSyncState('syncing')
        setSyncProgress({ done: 0, total: 0 })
        try {
            await syncOffline(location, setSyncProgress)
            setSyncState('done')
        } catch (e) {
            console.error('offline sync failed', e)
            setSyncState('error')
        }
    }

    const syncLabel = {
        idle: 'Save offline',
        syncing: syncProgress.total
            ? `Saving... ${Math.round((syncProgress.done / syncProgress.total) * 100)}%`
            : 'Saving...',
        done: 'Saved offline ✓',
        error: 'Sync failed – retry',
    }[syncState]

    const Option = ({isChecked, toggle, label}) => {
        return (
            <div className={styles.option}>
                <div className={styles.optionLabel}>{label}</div>
                <label className={styles.switch}>
                    <input checked={isChecked} onChange={toggle} type="checkbox" />
                    <span className={styles.slider}></span>
                </label>
            </div>
        )
    }

    return (
        <div>
            <div className={styles.optionsContainer}>
                {/* <Dropdown locations={locations} location={location} setLocation={setLocation}/> */}
                <Option label="Filter by month" isChecked={month!==0} toggle={toggleSeasonal}/>
                <Option label="Sort by relatedness" isChecked={sortMethod==='related'} toggle={toggleSort}/>
                <div className={styles.option}>
                    <div className={styles.optionLabel}>Use this guide offline</div>
                    <button
                        type="button"
                        className={`${styles.syncButton} ${syncState === 'done' ? styles.syncDone : ''}`}
                        onClick={handleSync}
                        disabled={syncState === 'syncing'}
                        data-sync-state={syncState}
                    >
                        {syncLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Options
